import { types } from 'mobx-state-tree'

export const QuestionType = types.union(
  types.literal('Multiple Choice'),
  types.literal('Multiple Response'),
  types.literal('True or False'),
  types.literal('Matching'),
  types.literal('Ordering'),
  types.literal('Open Text'),
  types.literal('Card'),
)
